const APP_LOADER_HIDE_TIMEOUT = 300;

export default {
    state: {
        hideLoaderTimeoutId: null,
        isAppLoaderEnabled: false,
    },
    mutations: {
        SET_LOADER_ENABLED: (state, isEnabled) => state.isAppLoaderEnabled = isEnabled,
        SET_HIDE_LAODER_TIMEOUT_ID: (state, id) => state.hideLoaderTimeoutId = id,
    },
    actions: {
        showAppLoader(ctx) {
            if (ctx.state.hideLoaderTimeoutId) {
                clearTimeout(ctx.state.hideLoaderTimeoutId);
                ctx.commit('SET_HIDE_LAODER_TIMEOUT_ID', null);
            } else {
                ctx.commit('SET_LOADER_ENABLED', true);
            }
        },
        hideAppLoader(ctx) {
            if (!ctx.state.hideLoaderTimeoutId) {
                ctx.commit('SET_HIDE_LAODER_TIMEOUT_ID', setTimeout(() => {
                    ctx.commit('SET_LOADER_ENABLED', false);
                    ctx.commit('SET_HIDE_LAODER_TIMEOUT_ID', null);
                }, APP_LOADER_HIDE_TIMEOUT));
            }
        },
    },
    getters: {
        isAppLoaderEnabled: state => state.isAppLoaderEnabled,
    },
};
